import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import QueryWrapper from 'graphql-client/QueryWrapper';

import {MoleculeHeavyAtomCountQuery} from './__generated/MoleculeHeavyAtomCountQuery';
import {ProteinAminoAcidsQuery} from './__generated/ProteinAminoAcidsQuery';

export const GENERATIVE_MODEL_RUNS_QUERY = gql`
  query GenerativeModelRunsQuery($proteinId: StrictString, $moleculeId: StrictString)
  @skipAudit
  @engComponent(name: MODEL_HUB) {
    generativeModelRuns(proteinId: $proteinId, moleculeId: $moleculeId) {
      id
      status
      createdAt
      zippedFullResultsFile {
        redirectUrl
      }
      topPredictedStructureFile {
        redirectUrl
      }
    }
  }
`;

export const MOLECULE_HEAVY_ATOM_COUNT_QUERY = gql`
  query MoleculeHeavyAtomCountQuery($moleculeIds: [StrictString!]!)
  @skipAudit
  @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            heavyAtomCount {
              ... on IntPropertyNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const MOLECULE_HEAVY_ATOM_COUNT_QUERY_WRAPPER: QueryWrapper<
  MoleculeHeavyAtomCountQuery,
  {moleculeIds: Array<string>}
> = {
  query: MOLECULE_HEAVY_ATOM_COUNT_QUERY,
};

export const PROTEIN_AMINO_ACIDS_QUERY: DocumentNode = gql`
  query ProteinAminoAcidsQuery($ids: [StrictString!]!) @skipAudit @engComponent(name: MOLBIO) {
    proteins(ids: $ids) {
      ... on ProteinNode {
        id
        experimentalCurrentVersion {
          dbId
          aminoAcids
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const PROTEIN_AMINO_ACIDS_QUERY_WRAPPER: QueryWrapper<ProteinAminoAcidsQuery, {ids: Array<string>}> = {
  query: PROTEIN_AMINO_ACIDS_QUERY,
};
